import Link from "next/link";
import Icon from "@/core/components/Icon/Icon";
import { BrandName } from "@/core/types/types";
import getBrandConfiguration from "@/core/utils/getBrandConfiguration";

const LogoLink = ({ brandName }: BrandName) => {
  const href: string = getBrandConfiguration(brandName).mainLogoUrls;
  const iconSrc: string = getBrandConfiguration(brandName).sidebarLogoSources;
  return (
    <Link href={href}>
      <Icon
        src={iconSrc}
        alt="Main logo"
        width={180}
        height={50}
        priority
        loading="eager"
      />
    </Link>
  );
};
export default LogoLink;
